module.exports = __webpack_public_path__ + "img/LOGO-PLANEAS-CONACYT-V2.f85f9e61.png";